<template>
  <div class="app-container">
    <el-card class="box-card mb10">
      <div style="display: flex;align-items: center">
        <div style="width: 460px;">
          <div style="font-size: 24px; font-weight: bold;margin-bottom: 10px;">
            <span>{{ $t('collectionCenter.AnJunManagementBoard') }}</span>
            <span style="margin-left: 20px;">{{ $t('GlobalSetObj.DeliveryOutlets') }}</span>
          </div>
          <div style="font-size: 15px" class="colorAdaeb3">
            <span>{{ $t('customerManagements.dataUpdateTime') }}</span>：
            {{ updateTime }}
          </div>
        </div>
        <div style="flex: 1;">
          <div style="display: flex;justify-content: flex-end">
            <div style="width: 350px;">
              <div class="dateMonthRadio">
                <div
                  class="colorAdaeb3 borderR"
                  :class="queryForm.period === 'yesterday' ? 'activeDateMonth' : ''"
                  @click="handlePeriodChange('yesterday')"
                >{{ $t('collectionCenter.yesterday') }}</div>
                <div
                  class="colorAdaeb3 borderR"
                  :class="queryForm.period === 'today' ? 'activeDateMonth' : ''"
                  @click="handlePeriodChange('today')"
                >{{ $t('newOrder.today') }}</div>
                <div
                  class="colorAdaeb3 borderR"
                  :class="queryForm.period === 'month' ? 'activeDateMonth' : ''"
                  @click="handlePeriodChange('month')"
                >{{ $t('newOrder.thisMonth') }}</div>
                <div
                  class="colorAdaeb3"
                  :class="queryForm.period === 'lastMonth' ? 'activeDateMonth' : ''"
                  @click="handlePeriodChange('lastMonth')"
                >{{ $t('collectionCenter.lastMonth') }}</div>
              </div>
              <div>
                <el-date-picker
                  v-model="queryForm.dateRange"
                  size="small"
                  type="daterange"
                  class="dateRangeStyle"
                  range-separator="-"
                  :start-placeholder="$t('GlobalSetObj.startDate')"
                  :end-placeholder="$t('GlobalSetObj.endDate')"
                />
              </div>
            </div>
            <div class="regionCon">
              <div style="display: flex;align-items: center;padding: 0 10px;width: 100%;">
                <div style="flex: 1;padding: 0 5px">
                  <div style="font-size: 13px;margin-bottom: 10px;" class="colorAdaeb3">{{ $t('collectionCenter.region') }}</div>
                  <div>
                    <el-select
                      v-model="queryForm.areaIdList"
                      :placeholder="$t('collectionCenter.pleaseChoose')"
                      size="small"
                      style="width: 100%;"
                      multiple
                      filterable
                      collapse-tags
                      @change="selectRegionChange"
                    >
                      <el-option
                        v-for="item in regionOptions"
                        :key="item.id"
                        :label="$i18n.locale === 'zh' ? item.zhName : item.puName"
                        :value="item.id"
                      />
                    </el-select>
                  </div>
                </div>
                <div style="width: 120px;padding-left: 10px">
                  <div style="font-size: 13px;margin-bottom: 10px;" class="colorAdaeb3">{{ $t('collectionCenter.state') }}</div>
                  <div>
                    <el-select
                      v-model="queryForm.stateList"
                      :placeholder="$t('collectionCenter.pleaseChoose')"
                      size="small"
                      style="width: 100%;"
                      multiple
                      filterable
                      collapse-tags
                      @change="selectStateChange"
                    >
                      <el-option
                        v-for="item in receiveStateList"
                        :key="item"
                        :label="item"
                        :value="item"
                      />
                    </el-select>
                  </div>
                </div>
                <div style="flex: 1;padding-left: 10px" class="selectIcon">
                  <div style="font-size: 13px;margin-bottom: 10px;" class="colorAdaeb3">{{ $t('collectionCenter.dot') }}</div>
                  <div>
                    <ElSelectV2
                      v-model="queryForm.departmentList"
                      multiple
                      clearable
                      :options="siteList"
                      filterable
                      collapse-tags
                      :placeholder="$t('operationCenter.PleaseSelect')"
                    />
                    <!--                    <el-select-->
                    <!--                      v-model="queryForm.departmentList"-->
                    <!--                      :placeholder="$t('collectionCenter.pleaseChoose')"-->
                    <!--                      size="small"-->
                    <!--                      style="width: 100%;"-->
                    <!--                      multiple-->
                    <!--                      collapse-tags-->
                    <!--                    >-->
                    <!--                      <el-option-->
                    <!--                        v-for="item in siteList"-->
                    <!--                        :key="item.id"-->
                    <!--                        :label="item.name"-->
                    <!--                        :value="item.name"-->
                    <!--                      />-->
                    <!--                    </el-select>-->
                  </div>
                </div>
                <div style="width: 54px;text-align: right">
                  <el-button
                    type="primary" size="mini" style="font-size: 20px;padding: 5px 10px"
                    icon="el-icon-search"
                    @click="getAllData"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-card>
    <el-row>
      <el-col :span="12" style="padding-right: 5px">
        <el-card class="box-card mb10">
          <div class="mb10 titleCon" style="line-height: 24px">入库数据监控 Monitoramento de dados de entrada
            <el-popover
              placement="bottom-start"
              trigger="hover"
            >
              <el-button
                slot="reference" type="text" size="mini"
                style="padding: 0;line-height: 16px"
              >
                <i class="el-icon-more" style="margin-left: 10px;font-size: 24px;color: #00A551;" />
              </el-button>
              <div>
                <el-tooltip
                  class="item" effect="light"
                  :content="$t('collectionCenter.detail')"
                  placement="top-start"
                >
                  <el-button size="mini" type="text" @click="viewDataTable(1)"><i class="iconfont icon-tiaozhuan" style="font-size: 20px" /></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item" effect="light" :content="$t('GlobalSetObj.Download')"
                  placement="top-start"
                >
                  <el-button size="mini" type="text" @click="downloadData(1)"><i class="iconfont icon-xiazai" style="font-size: 20px" /></el-button>
                </el-tooltip>
              </div>
            </el-popover>
          </div>
          <div style="display: flex;">
            <div style="flex: 1;padding: 0 5px">
              <div class="warehousingCon">
                <div style="font-size: 14px;margin-bottom: 5px;" class="colorAdaeb3">应入库票数</div>
                <div class="itemPu colorAdaeb3">Qtd. de Volumes para Entrada</div>
                <div class="itemQuantity">{{ inboundData.exceptWaybillCnt }}</div>
                <div class="itemIconCon" style="background: #fffbea;">
                  <span class="itemIcon" style="background: #fdf2c3;">
                    <i class="iconfont icon-ruku" style="font-size: 22px;color: #ffcb42" />
                  </span>
                </div>
              </div>
            </div>
            <div style="flex: 1;padding: 0 5px">
              <div class="warehousingCon">
                <div style="font-size: 14px;margin-bottom: 5px;" class="colorAdaeb3">实际入库票数</div>
                <div class="itemPu colorAdaeb3">Qtd. Real de Volumes para Entrada</div>
                <div class="itemQuantity">{{ inboundData.actualWaybillCnt }}</div>
                <div class="itemIconCon" style="background: #eef6ff;">
                  <span class="itemIcon" style="background: #dbeafe;">
                    <i class="iconfont icon-ruku" style="font-size: 22px;color: #6387d4" />
                  </span>
                </div>
              </div>
            </div>
            <div style="flex: 1;padding: 0 5px">
              <div class="warehousingCon">
                <div style="font-size: 14px;margin-bottom: 5px;" class="colorAdaeb3">入库差异</div>
                <div class="itemPu colorAdaeb3">Divergência de Entrada</div>
                <div class="itemQuantity">{{ inboundData.diffCnt }}</div>
                <div class="itemIconCon" style="background: #fef2f2;">
                  <span class="itemIcon" style="background: #ffe2e1;">
                    <i class="iconfont icon-a-zu143" style="font-size: 20px;color: #b46364" />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </el-card>
        <el-card class="box-card mb10">
          <div class="mb10 titleCon">退件数据监控 Monitoramento de dados de devolução
            <el-popover
              placement="bottom-start"
              trigger="hover"
            >
              <el-button
                slot="reference" type="text" size="mini"
                style="padding: 0;line-height: 16px"
              >
                <i class="el-icon-more" style="margin-left: 10px;font-size: 24px;color: #00A551;" />
              </el-button>
              <div>
                <el-tooltip
                  class="item" effect="light"
                  :content="$t('collectionCenter.detail')"
                  placement="top-start"
                >
                  <el-button size="mini" type="text" @click="viewDataTable(2)">
                    <i class="iconfont icon-tiaozhuan" style="font-size: 20px" />
                  </el-button>
                </el-tooltip>
                <el-tooltip
                  class="item" effect="light" :content="$t('GlobalSetObj.Download')"
                  placement="top-start"
                >
                  <el-button size="mini" type="text" @click="downloadData(2)">
                    <i class="iconfont icon-xiazai" style="font-size: 20px" />
                  </el-button>
                </el-tooltip>
              </div>
            </el-popover>
          </div>
          <div style="display: flex;">
            <div style="flex: 1;padding: 0 5px">
              <div class="warehousingCon">
                <div style="font-size: 14px;margin-bottom: 5px;" class="colorAdaeb3">应退件票数</div>
                <div class="itemPu colorAdaeb3">Qtd. de Volumes para Devolução</div>
                <div class="itemQuantity">{{ returnData.exceptReturnWaybillCnt }}</div>
                <div class="itemIconCon" style="background: #fffbea;">
                  <span class="itemIcon" style="background: #fdf2c3;">
                    <i class="iconfont icon-huituijian" style="font-size: 15px;color: #ffcb42" />
                  </span>
                </div>
              </div>
            </div>
            <div style="flex: 1;padding: 0 5px">
              <div class="warehousingCon">
                <div style="font-size: 14px;margin-bottom: 5px;" class="colorAdaeb3">及时退件票数</div>
                <div class="itemPu colorAdaeb3">Qtd. de Volumes para Devolução em Tempo Hábil</div>
                <div class="itemQuantity">{{ returnData.onTimeReturnCnt }}</div>
                <div class="itemIconCon" style="background: #eef6ff;">
                  <span class="itemIcon" style="background: #dbeafe;">
                    <i class="iconfont icon-huituijian" style="font-size: 15px;color: #6387d4" />
                  </span>
                </div>
              </div>
            </div>
            <div style="flex: 1;padding: 0 5px">
              <div class="warehousingCon">
                <div style="font-size: 14px;margin-bottom: 5px;" class="colorAdaeb3">及时退件率</div>
                <div class="itemPu colorAdaeb3">Taxa de Devolução em Tempo Hábil</div>
                <div class="itemQuantity">{{ returnData.onTimeReturnRate }}</div>
                <div class="itemIconCon" style="background: #eafdf7;">
                  <span class="itemIcon" style="background: #cefde6;">
                    <i class="iconfont icon-weixietongji_zhuantitongji" style="font-size: 22px;color: #329a72" />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12" style="padding-left: 5px">
        <el-card class="box-card">
          <div class="mb10 titleCon">滞留情况 Situação de Retenção
            <el-button
              size="mini" type="text" style="padding: 6px 0"
              @click="downloadData(5)"
            ><i class="iconfont icon-xiazai" style="font-size: 20px" /></el-button>
            <!--<el-popover
              placement="bottom-start"
              trigger="hover"
            >
              <el-button
                slot="reference" type="text" size="mini"
                style="padding: 0;line-height: 16px"
              >
                <i class="el-icon-more" style="margin-left: 10px;font-size: 24px;color: #00A551;" />
              </el-button>
              <div>
                <el-tooltip
                  class="item" effect="light"
                  :content="$t('collectionCenter.detail')"
                  placement="top-start"
                >
                  <el-button size="mini" type="text" @click="detainViewDataTable()"><i class="iconfont icon-tiaozhuan" style="font-size: 20px" /></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item" effect="light" :content="$t('GlobalSetObj.Download')"
                  placement="top-start"
                >
                  <el-button size="mini" type="text" @click="downloadData(5)"><i class="iconfont icon-xiazai" style="font-size: 20px" /></el-button>
                </el-tooltip>
              </div>
            </el-popover>-->
          </div>
          <div>
            <detain-efficiency-chart :chart-data="detainEfficiencyData" :total="detainTotal" />
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row class="mb10">
      <el-col :span="12" style="padding-right: 5px">
        <el-card class="box-card">
          <div class="mb10 titleCon">时效达成 Cumprimento do Prazo
            <el-popover
              placement="bottom-start"
              trigger="hover"
            >
              <el-button
                slot="reference" type="text" size="mini"
                style="padding: 0;line-height: 16px"
              >
                <i class="el-icon-more" style="margin-left: 10px;font-size: 24px;color: #00A551;" />
              </el-button>
              <div>
                <el-tooltip
                  class="item" effect="light"
                  :content="$t('collectionCenter.detail')"
                  placement="top-start"
                >
                  <el-button size="mini" type="text" @click="viewDataTable(3)"><i class="iconfont icon-tiaozhuan" style="font-size: 20px" /></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item" effect="light" :content="$t('GlobalSetObj.Download')"
                  placement="top-start"
                >
                  <el-button size="mini" type="text" @click="downloadData(3)"><i class="iconfont icon-xiazai" style="font-size: 20px" /></el-button>
                </el-tooltip>
              </div>
            </el-popover>
          </div>
          <div>
            <validity-efficiency-chart :chart-data="validityEfficiencyData" :title="validityTitle" />
          </div>
        </el-card>
      </el-col>
      <el-col :span="12" style="padding-left: 5px">
        <el-card class="box-card">
          <div class="mb10 titleCon">虚假签收监控 Monitoramento de Recebimento Falso
            <el-popover
              placement="bottom-start"
              trigger="hover"
            >
              <el-button
                slot="reference" type="text" size="mini"
                style="padding: 0;line-height: 16px"
              >
                <i class="el-icon-more" style="margin-left: 10px;font-size: 24px;color: #00A551;" />
              </el-button>
              <div>
                <el-tooltip
                  class="item" effect="light"
                  :content="$t('collectionCenter.detail')"
                  placement="top-start"
                >
                  <el-button size="mini" type="text" @click="viewDataTable(4)"><i class="iconfont icon-tiaozhuan" style="font-size: 20px" /></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item" effect="light" :content="$t('GlobalSetObj.Download')"
                  placement="top-start"
                >
                  <el-button size="mini" type="text" @click="downloadData(4)"><i class="iconfont icon-xiazai" style="font-size: 20px" /></el-button>
                </el-tooltip>
              </div>
            </el-popover>
          </div>
          <div>
            <fake-efficiency-chart :chart-data="falseDeliveryEfficiencyData" :title="falseDeliveryTitle" />
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="16" style="padding-right: 5px">
        <el-card class="box-card">
          <div class="mb10 titleCon">异常件监控 Monitoramento de Peças Anômalas
            <el-button
              size="mini" type="text" style="padding: 0"
              @click="downloadData(6)"
            >
              <i class="iconfont icon-xiazai" style="font-size: 20px" />
            </el-button>
          </div>
          <el-table :data="abnormalData" :height="335">
            <el-table-column
              label="序号 Nº" width="80" align="center"
              type="index"
            />
            <el-table-column label="异常件原因 Motivo das Peças Anômalas" prop="reason" />
            <el-table-column label="异常件数量 Qtd. de Peças Anômalas" prop="problemNum" />
            <el-table-column label="异常件占比% Percentual de Peças Anômalas" prop="problemRate">
              <template #default="{row}">
                {{ (row.problemRate * 100).toFixed(2) + '%' }}
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
      <el-col :span="8" style="padding-left: 5px">
        <el-card class="box-card">
          <div class="mb10 titleCon">效率监控 Monitoramento de Eficiência</div>
          <div class="warehousingCon" style="margin-bottom: 20px;">
            <div style="font-size: 14px;margin-bottom: 5px;width: 220px;" class="colorAdaeb3">首派及时率 Taxa de Pontualidade da Primeira Entrega</div>
            <div class="itemQuantity">{{ parseFloat(efficiencyData.firstDeliveryOnTimeRate * 100).toFixed(2) + '%' }}</div>
            <div class="itemIconCon" style="background: #ecfdf7;">
              <span class="itemIcon" style="background: #cdfce4;">
                <i class="iconfont icon-peisongzhong" style="font-size: 22px;color: #24af80" />
              </span>
            </div>
          </div>
          <div class="warehousingCon" style="margin-bottom: 20px;">
            <div style="font-size: 14px;margin-bottom: 5px;width: 240px;" class="colorAdaeb3">骑手上岗率 Taxa de Comparecimento dos Entregadores</div>
            <div class="itemQuantity">{{ parseFloat(efficiencyData.riderWorkRate * 100).toFixed(2) + '%' }}</div>
            <div class="itemIconCon" style="background: #ecfdf7;">
              <span class="itemIcon" style="background: #cdfce4;">
                <i class="iconfont icon-a-zu228" style="font-size: 20px;color: #24af80" />
              </span>
            </div>
          </div>
          <div class="warehousingCon mb10">
            <div style="font-size: 14px;margin-bottom: 5px;width: 220px;" class="colorAdaeb3">派件效能 Eficiência de Entrega</div>
            <div class="itemQuantity">{{ efficiencyData.deliveryEfficiencyRate }}</div>
            <div class="itemIconCon" style="background: #ecfdf7;">
              <span class="itemIcon" style="background: #cdfce4;">
                <i class="iconfont icon-xiaoneng" style="font-size: 22px;color: #24af80" />
              </span>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <!-- 详情 -->
    <el-dialog
      :title="titleTable"
      :visible.sync="dialogVisibleDetail"
      width="90%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div>
        <el-table
          ref="detailRef"
          :data="tableData"
          border
          height="500"
          :header-cell-style="{background:'#f2f2f2',color:'black'}"
        >
          <el-table-column
            :label="$t('GlobalSetObj.serial')" align="center" type="index"
            width="80"
          />
          <el-table-column
            v-for="(item, index) in columnTable"
            :key="index"
            :label="item.label"
            :prop="item.prop"
            align="center"
          />
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="downloadData(exportType)">{{ $t('collectionCenter.export') }}</el-button>
        <el-button size="small" @click="dialogVisibleDetail = false">{{ $t('collectionCenter.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { newOrder } from '@/lang/type/newOrder';
import dayjs from 'dayjs';
const startTime = dayjs().format('YYYY-MM-DD');
const endTime = dayjs().format('YYYY-MM-DD');
import { getDashboardChartData, getExportChartData, getRegionOptions, selectState } from '@/api/orderApi';
import detainEfficiencyChart from './com/detainEfficiencyChart.vue';
import validityEfficiencyChart from './com/validityEfficiencyChart.vue';
import fakeEfficiencyChart from './com/fakeEfficiencyChart.vue';
import { goResourceTaskList } from '@/utils/goExportList';
import {
  getSiteByStateAndTypeApi
} from '@/api/definiteResponsibilityAndPenalty';
import ElSelectV2 from 'el-select-v2';
export default {
  // 派送网点看板
  name: 'DetainEfficiencyChart',
  components: {
    ElSelectV2,
    detainEfficiencyChart,
    validityEfficiencyChart,
    fakeEfficiencyChart
  },
  data() {
    return {
      queryForm: {
        period: 'today',
        dateRange: [startTime, endTime],
        areaIdList: [],
        areaNameList: [],
        stateList: [],
        departmentList: []
      },
      regionOptions: [],
      receiveStateList: [],
      inboundData: {
        actualWaybillCnt: 0,
        diffCnt: 0,
        exceptWaybillCnt: 0
      },
      returnData: {
        exceptReturnWaybillCnt: 0,
        onTimeReturnCnt: 0,
        onTimeReturnRate: '0.00%'
      },
      detainEfficiencyData: [],
      detainTotal: 0,
      validityEfficiencyData: [],
      validityTitle: ['签收率 Taxa de entrega', '准时签收率 Taxa de entrega no prazo'],
      falseDeliveryEfficiencyData: [],
      falseDeliveryTitle: ['虚假签收票数 Número de Recebimentos Falsos', '虚假签收率 Taxa de Recebimento Falso'],
      abnormalData: [],
      efficiencyData: {
        deliveryEfficiencyRate: 0,
        firstDeliveryOnTimeRate: 0,
        riderWorkRate: 0
      },
      dialogVisibleDetail: false,
      columnTable: [],
      tableData: [],
      titleTable: '',
      exportType: 1,
      siteList: [],
      updateTime: ''
    };
  },
  computed: {
    newOrder() {
      return newOrder;
    }
  },
  created() {
    this.getAddressList();
    this.getAddress();
    this.getSiteList();
    this.getAllData();
  },
  methods: {
    // 导出
    downloadData(type) {
      let chartType = null;
      switch (type) {
        case 1: // 入库数据监控
          chartType = 'inWareHouseMonitor';
          break;
        case 2: // 退件数据监控
          chartType = 'returnMonitor';
          break;
        case 3: // 时效达成
          chartType = 'agingMonitor';
          break;
        case 4: // 虚假签收监控
          chartType = 'fakeSignMonitor';
          break;
        case 5: // 滞留情况
          chartType = 'stockMonitor';
          break;
        case 6: // 异常件监控
          chartType = 'problemMonitor';
          break;
      }
      const params = {
        dashboardType: 'DELIVERY_SITE_DASHBOARD',
        chartType: chartType,
        params: this.buildQueryParams()
      };
      getExportChartData(params).then(res => {
        if (res.code === 200) {
          this.dialogVisibleDetail = false;
          goResourceTaskList();
        }
      });
    },
    // 滞留详情
    async detainViewDataTable() {
      this.titleTable = '滞留情况 Situação de Retenção';
      try {
        const params = this.buildQueryParams();
        const res = await getDashboardChartData({
          dashboardType: 'DELIVERY_SITE_DASHBOARD',
          chartType: 'stockMonitor',
          params
        });
        if (res.code === 200 && res.data && res.data.chartData) {
          this.columnTable = [
            {
              label: '大区 Area extensa',
              prop: 'regionName'
            },
            {
              label: '网点所属州 Estado',
              prop: 'state'
            },
            {
              label: '网点名称 Ponto',
              prop: 'departmentName'
            },
            {
              label: '总库存 Estoque Total',
              prop: 'totalStayWaybillCnt'
            },
            {
              label: '24小时滞留 Retencao de 24h',
              prop: 'stay24HoursCnt'
            },
            {
              label: '48小时滞留 Retencao de 48h',
              prop: 'stay48HoursCnt'
            },
            {
              label: '72小时滞留 Retencao de 72h',
              prop: 'stay72HoursCnt'
            },
            {
              label: '7天滞留 Retencao de 7d',
              prop: 'stay7DaysCnt'
            },
            {
              label: '15天滞留 Retencao de 15d',
              prop: 'stay15DaysCnt'
            }
          ];
          this.tableData = res.data.chartData;
          this.dialogVisibleDetail = true;
          this.$refs.detailRef.doLayout();
        } else {
          // 数据为空时，清空表格
          this.tableData = [];
        }
      } catch (error) {
        console.error('获取揽收异常件数据失败:', error);
        // 异常时也清空数据
        this.tableData = [];
      }
    },
    // 查看详情
    viewDataTable(type) {
      this.exportType = type;
      this.tableData = [];
      if (type === 1) {
        this.titleTable = '入库数据监控 Monitoramento de dados de entrada';
        this.columnTable = [
          {
            label: '应入库票数 Qtd. de Volumes para Entrada',
            prop: 'exceptWaybillCnt'
          },
          {
            label: '实际入库票数 Qtd. Real de Volumes para Entrada',
            prop: 'actualWaybillCnt'
          },
          {
            label: '入库差异 Divergência de Entrada',
            prop: 'diffCnt'
          }
        ];
        this.tableData = [this.inboundData];
      } else if (type === 2) {
        this.titleTable = '退件数据监控 Monitoramento de dados de devolução';
        this.columnTable = [
          {
            label: '应退件票数 Qtd. de Volumes para Devolução',
            prop: 'exceptReturnWaybillCnt'
          },
          {
            label: '及时退件票数 Qtd. de Volumes para Devolução em Tempo Hábil',
            prop: 'onTimeReturnCnt'
          },
          {
            label: '及时退件率 Taxa de Devolução em Tempo Hábil',
            prop: 'onTimeReturnRate'
          }
        ];
        this.tableData = [this.returnData];
      } else if (type === 3) {
        this.titleTable = '时效达成 Cumprimento do Prazo';
        this.columnTable = [
          {
            label: '日期 Data',
            prop: 'dt'
          },
          {
            label: '签收率 Taxa de entrega',
            prop: 'signRate'
          },
          {
            label: '准时签收率 Taxa de entrega no prazo',
            prop: 'signOnTimeRate'
          }
        ];
        this.validityEfficiencyData.map(item => {
          const data = {
            dt: item.dt,
            signRate: (parseFloat(item.signRate) * 100).toFixed(2) + '%',
            signOnTimeRate: (parseFloat(item.signOnTimeRate) * 100).toFixed(2) + '%'
          };
          this.tableData.push(data);
        });
      } else if (type === 4) {
        this.titleTable = '虚假签收监控 Monitoramento de Recebimento Falso';
        this.columnTable = [
          {
            label: '日期 Data',
            prop: 'dt'
          },
          {
            label: '虚假签收票数 Número de Recebimentos Falsos',
            prop: 'fakeSignCnt'
          },
          {
            label: '虚假签收率 Taxa de Recebimento Falso',
            prop: 'fakeSignRate'
          }
        ];
        this.falseDeliveryEfficiencyData.map(item => {
          const data = {
            dt: item.dt,
            fakeSignCnt: item.fakeSignCnt,
            fakeSignRate: (parseFloat(item.fakeSignRate) * 100).toFixed(2) + '%'
          };
          this.tableData.push(data);
        });
      }
      this.dialogVisibleDetail = true;
      this.$refs.detailRef.doLayout();
    },
    // 时间段变化
    handlePeriodChange(period) {
      this.queryForm.period = period;
      const today = dayjs();
      switch (period) {
        case 'yesterday':
          this.queryForm.dateRange = [
            today.subtract(1, 'day').format('YYYY-MM-DD'),
            today.subtract(1, 'day').format('YYYY-MM-DD')
          ];
          break;
        case 'today':
          this.queryForm.dateRange = [today.format('YYYY-MM-DD'), today.format('YYYY-MM-DD')];
          break;
        case 'month':
          this.queryForm.dateRange = [
            today.startOf('month').format('YYYY-MM-DD'),
            today.format('YYYY-MM-DD')
          ];
          break;
        case 'lastMonth':
          this.queryForm.dateRange = [
            today.subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
            today.subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
          ];
          break;
      }
      this.getAllData();
    },
    // 查询条件处理
    buildQueryParams() {
      const params = {
        period: this.queryForm.period,
        areaNameList: this.queryForm.areaNameList,
        stateList: this.queryForm.stateList,
        departmentList: this.queryForm.departmentList
      };

      // 日期范围
      if (this.queryForm.dateRange && this.queryForm.dateRange.length === 2) {
        params.startDate = dayjs(this.queryForm.dateRange[0]).format('YYYY-MM-DD');
        params.endDate = dayjs(this.queryForm.dateRange[1]).format('YYYY-MM-DD');
      }

      return params;
    },
    getAllData() {
      this.getUpdateTime();
      this.getInboundData();
      this.getReturnData();
      this.getDetainEfficiencyData();
      this.getValidityEfficiencyData();
      this.getFakeSignData();
      this.getProblemData();
      this.getEfficiencyData();
    },
    // 获取更新时间
    async getUpdateTime() {
      try {
        const params = this.buildQueryParams();
        const res = await getDashboardChartData({
          dashboardType: 'DELIVERY_SITE_DASHBOARD',
          chartType: 'updateTime',
          params
        });
        if (res.code === 200 && res.data && res.data.chartData) {
          this.updateTime = res.data.chartData;
        } else {
          this.updateTime = '';
        }
      } catch (error) {
        console.error('获取揽收异常件数据失败:', error);
        // 异常时也清空数据
        this.updateTime = '';
      }
    },
    // 入库数据监控
    async getInboundData() {
      try {
        const params = this.buildQueryParams();
        const res = await getDashboardChartData({
          dashboardType: 'DELIVERY_SITE_DASHBOARD',
          chartType: 'inWareHouseMonitor',
          params
        });
        if (res.code === 200 && res.data && res.data.chartData) {
          this.inboundData = res.data.chartData;
        } else {
          // 数据为空时，清空表格
          this.inboundData = {
            actualWaybillCnt: 0,
            diffCnt: 0,
            exceptWaybillCnt: 0
          };
        }
      } catch (error) {
        console.error('获取揽收异常件数据失败:', error);
        // 异常时也清空数据
        this.inboundData = {
          actualWaybillCnt: 0,
          diffCnt: 0,
          exceptWaybillCnt: 0
        };
      }
    },
    // 退件数据监控
    async getReturnData() {
      try {
        const params = this.buildQueryParams();
        const res = await getDashboardChartData({
          dashboardType: 'DELIVERY_SITE_DASHBOARD',
          chartType: 'returnMonitor',
          params
        });
        if (res.code === 200 && res.data && res.data.chartData) {
          this.returnData = {
            exceptReturnWaybillCnt: res.data.chartData.exceptReturnWaybillCnt,
            onTimeReturnCnt: res.data.chartData.onTimeReturnCnt,
            onTimeReturnRate: (res.data.chartData.onTimeReturnRate * 100).toFixed(2) + '%'
          };
        } else {
          // 数据为空时，清空表格
          this.returnData = {
            exceptReturnWaybillCnt: 0,
            onTimeReturnCnt: 0,
            onTimeReturnRate: '0.00%'
          };
        }
      } catch (error) {
        console.error('获取揽收异常件数据失败:', error);
        // 异常时也清空数据
        this.returnData = {
          exceptReturnWaybillCnt: 0,
          onTimeReturnCnt: 0,
          onTimeReturnRate: '0.00%'
        };
      }
    },
    // 滞留情况
    async getDetainEfficiencyData() {
      try {
        const params = this.buildQueryParams();
        const res = await getDashboardChartData({
          dashboardType: 'DELIVERY_SITE_DASHBOARD',
          chartType: 'stockMonitor',
          params
        });
        if (res.code === 200 && res.data && res.data.chartData) {
          this.detainEfficiencyData = [
            { total: res.data.chartData.totalStayWaybillCnt || 0, detain: res.data.chartData.stay24HoursCnt || 0, purposeState: '24小时' },
            { total: res.data.chartData.totalStayWaybillCnt || 0, detain: res.data.chartData.stay48HoursCnt || 0, purposeState: '48小时' },
            { total: res.data.chartData.totalStayWaybillCnt || 0, detain: res.data.chartData.stay72HoursCnt || 0, purposeState: '72小时' },
            { total: res.data.chartData.totalStayWaybillCnt || 0, detain: res.data.chartData.stay7DaysCnt || 0, purposeState: '7天' },
            { total: res.data.chartData.totalStayWaybillCnt || 0, detain: res.data.chartData.stay15DaysCnt || 0, purposeState: '15天' }
          ];
          this.detainTotal = res.data.chartData.totalStayWaybillCnt || 0;
        } else {
          // 数据为空时，清空表格
          this.detainEfficiencyData = [];
          this.detainTotal = 0;
        }
      } catch (error) {
        console.error('获取揽收异常件数据失败:', error);
        // 异常时也清空数据
        this.detainEfficiencyData = [];
        this.detainTotal = 0;
      }
    },
    // 时效达成
    async getValidityEfficiencyData() {
      try {
        const params = this.buildQueryParams();
        const res = await getDashboardChartData({
          dashboardType: 'DELIVERY_SITE_DASHBOARD',
          chartType: 'agingMonitor',
          params
        });
        if (res.code === 200 && res.data && res.data.chartData) {
          this.validityEfficiencyData = res.data.chartData;
        } else {
          // 数据为空时，清空表格
          this.validityEfficiencyData = [];
        }
      } catch (error) {
        console.error('获取揽收异常件数据失败:', error);
        // 异常时也清空数据
        this.validityEfficiencyData = [];
      }
    },
    // 虚假签收
    async getFakeSignData() {
      try {
        const params = this.buildQueryParams();
        const res = await getDashboardChartData({
          dashboardType: 'DELIVERY_SITE_DASHBOARD',
          chartType: 'fakeSignMonitor',
          params
        });
        if (res.code === 200 && res.data && res.data.chartData) {
          this.falseDeliveryEfficiencyData = res.data.chartData;
        } else {
          // 数据为空时，清空表格
          this.falseDeliveryEfficiencyData = [];
        }
      } catch (error) {
        console.error('获取揽收异常件数据失败:', error);
        // 异常时也清空数据
        this.falseDeliveryEfficiencyData = [];
      }
    },
    // 问题件监控
    async getProblemData() {
      try {
        const params = this.buildQueryParams();
        const res = await getDashboardChartData({
          dashboardType: 'DELIVERY_SITE_DASHBOARD',
          chartType: 'problemMonitor',
          params
        });
        if (res.code === 200 && res.data && res.data.chartData) {
          this.abnormalData = res.data.chartData;
        } else {
          // 数据为空时，清空表格
          this.abnormalData = [];
        }
      } catch (error) {
        console.error('获取揽收异常件数据失败:', error);
        // 异常时也清空数据
        this.abnormalData = [];
      }
    },
    // 监控效率
    async getEfficiencyData() {
      try {
        const params = this.buildQueryParams();
        const res = await getDashboardChartData({
          dashboardType: 'DELIVERY_SITE_DASHBOARD',
          chartType: 'efficiencyMonitor',
          params
        });
        if (res.code === 200 && res.data && res.data.chartData) {
          this.efficiencyData = res.data.chartData;
        } else {
          // 数据为空时，清空表格
          this.efficiencyData = {
            deliveryEfficiencyRate: 0,
            firstDeliveryOnTimeRate: 0,
            riderWorkRate: 0
          };
        }
      } catch (error) {
        console.error('获取揽收异常件数据失败:', error);
        // 异常时也清空数据
        this.efficiencyData = {
          deliveryEfficiencyRate: 0,
          firstDeliveryOnTimeRate: 0,
          riderWorkRate: 0
        };
      }
    },
    // 获取大区选项
    getAddressList() {
      getRegionOptions().then(res => {
        if (res.code === 200) {
          this.regionOptions = res.data;
        }
      });
    },
    // 选择大区变化
    selectRegionChange() {
      this.queryForm.stateList = [];
      this.queryForm.departmentList = [];
      this.receiveStateList = [];
      this.queryForm.areaNameList = [];
      if (this.queryForm.areaIdList.length > 0) {
        this.regionOptions.map(item => {
          if (this.queryForm.areaIdList.includes(item.id)) {
            this.queryForm.areaNameList.push(item.zhName);
            this.receiveStateList.push(...item.states);
          }
        });
      } else {
        this.getAddress();
      }
      this.getSiteList();
    },
    // 网点选项变化
    selectStateChange() {
      this.queryForm.departmentList = [];
      this.getSiteList();
    },
    getAddress(name = '') {
      // level 0 州    1 城市   2 地区
      const params = {
        pageNumber: 1,
        pageSize: 200,
        params: {
          name,
          countryName: 'Brazil'
        }
      };
      selectState(params, false).then((res) => {
        if (res.code === 200) {
          this.receiveStateList = res.data.records.map(item => {
            return item.shortName;
          });
        }
      });
    },
    // 查询网点
    getSiteList() {
      const param = {
        stateList: this.queryForm.stateList,
        siteBusinessType: 1,
        regionIds: this.queryForm.areaIdList
      };
      getSiteByStateAndTypeApi(param).then(res => {
        if (res.code === 200) {
          res.data.map(item => {
            item.label = item.name;
            item.value = item.name;
          });
          this.siteList = res.data;
        }
      });
    }
  }
};
</script>

<style>
.selectIcon .el-input__icon {
  line-height: 24px;
}
.selectIcon .el-tag--small {
  padding: 0;
}
.colorAdaeb3 {
  color: #898c8b;
}
.borderR {
  border-right: 1px solid #dcdfe6;
}
.activeDateMonth {
  background: #00A551 !important;
  color: #fff;
}
.dateMonthRadio {
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  border: 1px solid #dcdfe6;
  border-radius: 10px;
}
.dateMonthRadio div {
  width: 25%;
  cursor: pointer;
  text-align: center;
  font-size: 13px;
  padding: 5px 0;
  background: #f9fbfa;
}
.regionCon {
  border-radius: 10px;
  margin-left: 20px;
  width: 510px;
  border: 1px solid #dcdfe6;
  background: #f9fbfa;
  display: flex;
  align-items: center;
}
.regionCon .el-input__inner {
  border: 0;
  padding: 0;
  background: transparent;
  height: 24px;
  line-height: 24px;
}
.regionCon .el-input--small .el-input__icon {
  line-height: 24px;
}
.dateRangeStyle {
  background: #f9fbfa;
  border-radius: 10px;
}
.dateRangeStyle .el-range-input {
  background: #f9fbfa;
}
.titleCon {
  font-weight: bold;
  font-size: 15px
}
.warehousingCon {
  background: #fafafa;
  padding: 10px;
  position:relative;
  overflow:hidden;
}
.itemPu {
  font-size: 13px;
  width: 140px;
  line-height: 14px;
  height: 28px;
}
.itemQuantity {
  margin-top: 10px;
  font-weight: bold;
  font-size: 20px;
  line-height: 30px;
  height: 30px;
}
.itemIconCon {
  position: absolute;
  top: 0;
  right: 0;
  width: 80px;
  height: 52px;
  border-radius: 0 12px 0 100%;
}
.itemIcon {
  display: inline-block;
  width: 35px;
  height: 35px;
  text-align: center;
  line-height: 35px;
  border-radius: 5px;
  margin-left: 35px;
  margin-top: 18px;
}
</style>
